import { createSlice } from "@reduxjs/toolkit";
import { IReduxState } from "../../interfaces/IReduxState";

// Define the interface for the course data structure
export interface MyCourseData {
  id: number;
  full_name: string;
  short_name: string;
  course_id: string;
  course_category: {
    id: number;
    name: string;
    course_category_id: string;
  };
  subjects: Array<{
    id: number;
    name: string;
    duration: number;
    resources: Array<{
      resource_id: string;
      resource_type: string;
      mime_type: string;
      video?: {
        id: number;
        title: string;
        description: string;
        total_duration: number;
      };
    }>;
  }>;
  description: string;
  duration: number;
  image: string;
  status: boolean;
  yeargroup_country_map: Array<{
    id: number;
    year_group_data: {
      id: number;
      year_group: string;
    };
    region: {
      id: number;
      region: string;
      timezone: string;
    };
  }>;
}

export const MyCourseSlice = createSlice({
  name: "MyCourseSlice",
  initialState: {} as IReduxState<MyCourseData>,
  reducers: {
    fetchMyCourse: (state) => {
      state.isLoading = true;
    },
    successMyCourse: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
    failureMyCourse: (state, action) => {
      state.data = action.payload;
      state.isLoading = false;
    },
  },
});

export const { failureMyCourse, fetchMyCourse, successMyCourse } = MyCourseSlice.actions;

export default MyCourseSlice.reducer;
